import { useChains } from "src/components/FetchConfig";
import { defaultListParams } from "src/features/common/constants/defaultListParams";
import { cleanParams } from "src/features/common/helpers/cleanParams";
import { DefaultListParams } from "src/features/common/types/DefaultListParams";
import { FilterFields } from "../types/FilterFields";
import { isEmpty } from "lodash";

const useGetListParams = () => {
  const { selectChainByPieces } = useChains();
  const getListParams = (fields: FilterFields) => {
    const { chainName, assetName, riskType, status, addressBookOrder } = fields;

    const { chain_id, chain_type } = selectChainByPieces({
      chain_name: chainName,
    });

    const params: DefaultListParams = {
      ...defaultListParams,
      chain_id,
      chain_type,
      assetName,
      statuses: isEmpty(status) ? [] : [status],
      riskType,
      walletAddress: addressBookOrder.to_address,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
